export const zh = {
  title: '完整的森林景观',
  subtitle: '(2000/2013/2016/2020)',
  download_data: 'https://data.globalforestwatch.org/documents/gfw::intact-forest-landscapes/about',
  learn_more: 'http://www.intactforests.org/',
  content: [
    {
      label: '功能',
      value:
        '确定世界上剩余的最后一片未被分割的森林景观，其面积足以保留所有原生生物多样性，截至 2020 年没有出现人为改变的迹象。该图层还显示了从 2000 年到 2020 年完整森林景观范围的减少。',
    },
    {
      label: '分辨率',
      value: '大约 1:1,000,000',
    },
    {
      label: '地理覆盖范围',
      value: '全球',
    },
    {
      label: '来源',
      value:
        'Potapov, P., M. C. Hansen, L. Laestadius, S. Turubanova, A. Yaroshenko, C. Thies, W. Smith, I. Zhuravleva, A. Komarova, S. Minnemeyer, and E. Esipova. 2017. "The last frontiers of wilderness: Tracking loss of intact forest landscapes from 2000 to 2013." Science Advances 3: e1600821.',
    },
    {
      label: '内容日期',
      value: 2020,
    },
    {
      label: '注意事项',
      value:
        '世界 IFL 地图由专家对陆地卫星图像的视觉诠释来创建。由于图像的分辨率的限制以及缺少一些地区土地使用的辅助信息的缺乏，该地图可能包含不准确的内容。此外，该方法假设在接近道路或其他基础设施的火灾可能是由人类造成的，并且因此构成人为干扰的一种形式。这种假设可能导致 IFL 对寒带生物群落的低估。',
    },
    {
      label: '许可证',
      value: 'CC BY 4.0',
    },
  ],
  overview: {
    label: '概览',
    value:
      '原生林景观(IFL) 数据集标识森林内完整的自然生态系统区域，这些区域没有显著的人类活动迹象，且足以承载所有本地物种的生物多样性，包括广域分布物种的可存活族群。为绘制 IFL 区域的地图，一系列适用全球、可轻易复制的标准得以诞生，可复制性使其能够随时间推移反复评估和验证。IFL 区域被定义为不可分断的景观，面积至少 50,000 公顷，宽度须大于 10 千米。这些是根据 2000 年陆地卫星影像绘制而成。',
  },
  citation: {
    label: '引用',
    value:
      'Greenpeace, University of Maryland, World Resources Institute and Transparent World. “Intact Forest Landscapes. 2000/2013/2016/2020” Accessed through Global Forest Watch on 31/01/2025. www.globalforestwatch.org',
  },
};
